import api from './api';

const appointmentService = {
  getAllAppointments: (params) => api.get('/appointments/admin/all', { params }),
  updateStatus: (id, data) => api.patch(`/appointments/admin/${id}/status`, data),
  getStats: () => api.get('/appointments/admin/stats'),
};

export default appointmentService;
